<!--
  功能：自定义列--左侧二级导航循环
-->
<template>
  <div>
    <el-dialog title="自定义列" class="set-col-dialog"
    :visible="colsDialogFlag" @close="colsDialogClose"
    width="840px" :close-on-click-modal="false">
      <div class="set-col-box">
        <div class="choose-col-box">
          <div class="col-titile">可添加的列</div>
          <div class="choose-col">
            <!-- 左侧列表导航 -->
            <div class="choose-title-list" v-if="leftMenu">
              <div v-for="(firItem, firIndex) in listdata" :key="firIndex">
                <div class="choose-title">{{firItem.dictName}}</div>
                <ul class="choose-title-ul">
                  <li v-for="(secItem, secIndex) in firItem.columnData" :key="secIndex" @click="goToList(`id${firIndex}-${secIndex}`)">{{secItem.dictName}}</li>
                </ul>
              </div>
            </div>
            <!-- 右侧勾选列表 -->
            <div class="choose-list">
              <div v-for="(firItem, firIndex) in listdata" :key="firIndex">
                <div class="choose-list-item" :id="`id${firIndex}-${secIndex}`" v-for="(secItem, secIndex) in firItem.columnData" :key="secIndex">
                  <div class="choose-item-title">{{secItem.dictName}}</div>
                  <div class="choose-list-ul">
                    <el-checkbox class="choose-list-li" v-model="secItem.myChecked" :indeterminate="secItem.isIndeterminate" @change="firstChanged(firIndex,secIndex)">全选</el-checkbox>
                    <el-checkbox class="choose-list-li" v-for="(thirdItem, thirdIndex) in secItem.columnDetailData" :key="thirdIndex"
                    :disabled="thirdItem.disabledChecked"
                    v-model="thirdItem.myChecked" @change="secondChanged(firIndex,secIndex,thirdIndex,thirdItem.id)">{{ thirdItem.dictName }}</el-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="already-col-box">
          <div class="col-titile">已选{{checkedList.length}}列</div>
          <draggable tag="ul" :list="checkedList" class="list-group" handle=".handle" filter=".unmover" :group= "'handle'" :sort= "true">
            <li class="list-group-item" v-for="(item, idx) in checkedList" :key="idx"
            :class="item.disabledChecked ? 'unmover' : 'handle'">
              <i class="iconfont icon-navBtnOpen handle"></i>
              <span class="text handle">{{ item.dictName }} </span>
              <i class="el-icon-close" @click="item.disabledChecked ? '' : removeAt(idx)"></i>
            </li>
          </draggable>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="colsDialogClose">取 消</el-button>
        <el-button type="primary" @click="datadragEnd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  name: 'setColumn',
  components: {draggable},
  props: [
    'colsDialogFlag',
    'leftMenu',
    'listdata',
    'checkedList'
  ],
  data () {
    return {
      // visible: false
      // 勾选上的列表
    }
  },
  methods: {
    colsDialogClose () {
      this.$emit('update:colsDialogFlag', false)
    },
    /*
    * 自定义列的对话框
    */
    // 自定义列--列表导航跳转
    goToList (idVal) {
      document.querySelector('#' + idVal).scrollIntoView(true)
    },
    // 汇总数据改变时，控制全选选项是否勾选
    chooseListChanged () {
      for (let i = 0; i < this.listdata.length; i++) {
        for (let j = 0; j < this.listdata[i].columnData.length; j++) {
          let count = 0
          for (let k = 0; k < this.listdata[i].columnData[j].columnDetailData.length; k++) {
            if (this.listdata[i].columnData[j].columnDetailData[k].myChecked) {
              count++
            }
            if (count === this.listdata[i].columnData[j].columnDetailData.length) {
              // 二级全勾选  一级勾选
              this.$set(this.listdata[i].columnData[j], 'myChecked', true)
              this.$set(this.listdata[i].columnData[j], 'isIndeterminate', false)
            } else {
              // 二级不勾选  一级不勾选
              this.$set(this.listdata[i].columnData[j], 'myChecked', false)
              if (count > 0) {
                this.$set(this.listdata[i].columnData[j], 'isIndeterminate', true)
              } else {
                this.$set(this.listdata[i].columnData[j], 'isIndeterminate', false)
              }
            }
          }
        }
      }
    },
    // 一级change事件，点击全选对应右侧已选列表相应改变
    firstChanged (firIndex, secIndex) {
      this.listdata[firIndex].columnData[secIndex].isIndeterminate = false
      const { columnDetailData } = this.listdata[firIndex].columnData[secIndex]
      if (this.listdata[firIndex].columnData[secIndex].myChecked === false) {
        columnDetailData.forEach((item) => {
          this.$set(item, 'myChecked', false)
        })
        for (let i = 0; i < columnDetailData.length; i++) {
          for (let j = 0; j < this.checkedList.length; j++) {
            if (columnDetailData[i].id === this.checkedList[j].id) {
              this.checkedList.splice(j, 1)
            }
          }
        }
      } else {
        columnDetailData.forEach((item) => {
          this.$set(item, 'myChecked', true)
        })
        for (let i = 0; i < columnDetailData.length; i++) {
          let count = 0
          if (this.checkedList.length !== 0) {
            for (let j = 0; j < this.checkedList.length; j++) {
              if (columnDetailData[i].id !== this.checkedList[j].id) {
                count += 1
              }
              if (count === this.checkedList.length) {
                this.checkedList.push(columnDetailData[i])
              }
            }
          } else {
            this.checkedList.push(columnDetailData[i])
          }
        }
      }
    },
    // 二级change事件
    secondChanged (firIndex, secIndex, thirdIndex, thirdItemId) {
      if (this.listdata[firIndex].columnData[secIndex].columnDetailData[thirdIndex].myChecked) {
        this.checkedList.push(this.listdata[firIndex].columnData[secIndex].columnDetailData[thirdIndex])
      } else {
        for (let i = 0; i < this.checkedList.length; i++) {
          if (this.checkedList[i].id === thirdItemId) {
            this.checkedList.splice(i, 1)
          }
        }
      }
      this.chooseListChanged()
    },
    // 移除选择的列名
    removeAt (idx) {
      // this.checkedList[idx].myChecked=false
      this.$set(this.checkedList[idx], 'myChecked', false)
      for (let i = 0; i < this.listdata.length; i++) {
        for (let j = 0; j < this.listdata[i].columnData.length; j++) {
          for (let k = 0; k < this.listdata[i].columnData[j].columnDetailData.length; k++) {
            if (this.listdata[i].columnData[j].columnDetailData[k].id === this.checkedList[idx].id) {
              this.listdata[i].columnData[j].columnDetailData[k].myChecked = false
            }
          }
        }
      }
      this.checkedList.splice(idx, 1) // 移除列名
      this.chooseListChanged()
    },
    // 点击确定，获取拖动排序的列表
    datadragEnd (evt) {
      evt.preventDefault()
      // 隐藏对话框
      // this.visible = false
      this.$emit('dragEnd')
    }
  },
  watch: {
    // colsDialogFlag () {
    //   this.visible = this.colsDialogFlag
    // }
    colsDialogFlag: {
      deep: true,
      handler: function(newVal, oldV) {
        console.log('colsDialogFlag', newVal)
        if (newVal) {
          // 主要为初始化半选状态
          if (this.listdata && this.listdata.length) {
            this.chooseListChanged()
          }
        }
      }
    }
  },
  mounted () {
    // 为了防止火狐浏览器拖拽的时候以新标签打开，此代码真实有效
    document.body.ondrop = function (event) {
      event.preventDefault()
      event.stopPropagation()
    }
  }
}
</script>

<style lang="less" scoped>
// 自定义列的对话框
.set-col-dialog{
  .set-col-box{
    display: flex;
    flex-direction: row;
    height: 450px;
    // 可添加的列
    .choose-col-box{
      border: 1px solid #EDEEF2;
      width: 70%;
      margin-right: 29px;
      .col-titile{
        padding: 12px 0.15rem;
        background-color: #F6F7FB;
        border-bottom: 1px solid #EDEEF2;
      }
      .choose-col{
        display: flex;
        flex-direction: row;
        height: calc(100% - 44px);
        .choose-title-list{
          width: 32%;
          height: 100%;
          border-right: 1px solid #EDEEF2;
          overflow-y: auto;
          .choose-title{
            color: #2C3437;
            padding: 0.18rem 0.16rem;
          }
          .choose-title-ul{
            padding-left: 0.31rem;
            color: #666666;
            li{
              padding-bottom: 0.15rem;
              cursor: pointer;
            }
          }
        }
        .choose-list{
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
          .choose-list-item{
            padding: 0.18rem 0.20rem;
            border-bottom: 1px solid #EDEEF2;
            .choose-item-title{
              padding-bottom: 0.03rem;
            }
            .choose-list-ul{
              display: flex;
              flex-wrap: wrap;
              .choose-list-li{
                width: 49%;
                margin-right: 1%;
                padding-top: 0.15rem;
                overflow: hidden;
              }
            }
          }
          .choose-list-item:last-child{
            border-bottom: none;
          }
        }
      }
    }
    // 已选列表
    .already-col-box{
      flex: 1;
      border: 1px solid #eee;
      .col-titile{
        padding: 12px 0.15rem;
        background-color: #F6F7FB;
        border-bottom: 1px solid #EDEEF2;
      }
      .list-group{
        height: calc(100% - 44px);
        overflow-y: auto;
        .list-group-item{
          margin: 0.1rem 0.16rem;
          padding: 0.05rem 0.12rem 0.07rem 0.05rem;
          background-color: #F8F8F8;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #919191;
          &.handle{
            cursor: move;
            .el-icon-close{
              cursor: pointer;
            }
          }
          &.unmover{
            cursor: no-drop;
            .el-icon-close{
              cursor: no-drop;
            }
          }
          .icon-navBtnOpen{
            margin-top: 2px;
          }
          .text{
            flex: 1;
            margin: 0 3px;
            color: #9B9B9B;
            font-size: 12px;
          }

        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/setColumn.vue